export const bbWallets = [
  '0x4d36f353b98E568aE8C768613d4f549C000EfBe5', // emergency

  '0x12f45b75bcE61B15495D158e19152B8Fda1862Ce',
];

export const launchWallets = [
  '0xE9C142bA64f07338E86069713c2FB6BCB1087252',
];

export const massiveWallets = [
  '0xa11862326d9391F19CCA45705A9ED8DA958d2D26',
];

// export default { 
//   bbWallets,
//   launchWallets,
//   massiveWallets
// };